// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // apiUrl: 'http://10.100.60.76:98/api/'
  // apiUrl: 'http://112.133.194.159:98/api/'
  // apiUrl: 'http://cada.hartron.io:98/api/',
  // apiUrl: 'http://203.100.79.155/api1/api/'
  
  
  // // for pre prod
  // production: false,
  // staging: true,
  // apiUrl: 'http://203.100.79.155:90/api1/api/'

  // for prod
  production: true,
  staging: false,
  apiUrl: 'https://micada.haryana.gov.in:8443/api/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
